export default __webpack_public_path__ + "static/img-slider-08-69dc6ae1f26e206de9c31826900de2ff.jpg";